// extracted by mini-css-extract-plugin
export default {"addItemFormContainer":"AddItemForm_addItemFormContainer__uRDI-","addInputForm":"AddItemForm_addInputForm__x7Ce5"};